/* My School (brightivity.dev/school — M8, shared with StudioCore's org queue). Responses are {success, data}. */
import { api } from './client.js';

const call = async (path, opts) => {
  const r = await api(path, opts);
  return r.ok && r.data && r.data.success !== false ? { ok: true, ...(r.data.data || {}) } : { ok: false, status: r.status, error: r.error || (r.data && r.data.error) };
};

export const schoolMe = () => call('/school/me');
export const listQueue = (status) => call(`/school/print-queue?status=${status}`);
export const listMine = () => call('/school/print-queue/mine');
export const jobImage = (id) => call(`/school/print-queue/${id}/image`);
export const approveJob = (id) => call(`/school/print-queue/${id}/approve`, { method: 'POST', body: {} });
export const rejectJob = (id, note) => call(`/school/print-queue/${id}/reject`, { method: 'POST', body: note ? { note } : {} });
export const approveGroup = (gid) => call(`/school/print-queue/group/${gid}/approve`, { method: 'POST', body: {} });
export const rejectGroup = (gid, note) => call(`/school/print-queue/group/${gid}/reject`, { method: 'POST', body: note ? { note } : {} });
export const cancelJob = (id) => call(`/school/print-queue/${id}/cancel`, { method: 'POST', body: {} });
export const dismissJob = (id) => call(`/school/print-queue/${id}/dismiss`, { method: 'POST', body: {} });
export const markPrinted = (id, body) => call(`/school/print-queue/${id}/printed`, { method: 'POST', body });
export const markPrintFailed = (id, body) => call(`/school/print-queue/${id}/print-failed`, { method: 'POST', body });
export const listUsers = () => call('/school/users');
export const setPrintPermission = (userId, canPrint) => call(`/school/users/${userId}/print-permission`, { method: 'POST', body: { canPrint } });
export const listLicenses = () => call('/school/licenses');
export const resetLicense = (id) => call(`/school/licenses/${id}/reset`, { method: 'POST', body: {} });
export const userActivity = (userId, feed) => call(`/school/activity/${userId}?feed=${feed}`);

/** Upload a File for an approval request → {ok, key}. */
export async function uploadForApproval(file, slot = 'image') {
  const t = await call('/school/print-queue/upload-token', { method: 'POST', body: { contentType: file.type || 'image/png', slot } });
  if (!t.ok) return t;
  const res = await fetch(t.uploadUrl, { method: 'PUT', headers: { 'Content-Type': file.type || 'image/png' }, body: file });
  return res.ok ? { ok: true, key: t.key } : { ok: false, error: `Upload failed (${res.status})` };
}
/** A Brightivity image (library / printables) copied server-side into the queue → {ok, imageKey, thumbKey}. */
export const ingestForApproval = (imageUrl, thumbUrl) => call('/school/print-queue/ingest-url', { method: 'POST', body: { imageUrl, ...(thumbUrl ? { thumbUrl } : {}) } });
export const submitForApproval = (body) => call('/school/print-queue', { method: 'POST', body });
